import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-auth-navbar",
  templateUrl: "./auth-navbar.component.html",
  styles: `
    @media (min-width: 640px) {
      .sm\:hidden {
        display: none;
      }
    }
  `
})
export class AuthNavbarComponent implements OnInit {
  navbarOpen = false;
  isDropdownOpen = false;

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {}

  showToast() {
    this.messageService.add({severity: 'info', summary:'hiii', detail: 'sEtse fdrgrd d'})
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  setNavbarOpen() {
    this.navbarOpen = !this.navbarOpen;
  }
}
